












import { Component, Vue, Watch } from 'vue-property-decorator';
import Offline from './components/offline/Offline.vue'
import { cryptoWaitReady } from '@polkadot/util-crypto';
import keyring from '@polkadot/ui-keyring';
import SidebarMenu from './components/SidebarMenu.vue';
import Connector from '@vue-polkadot/vue-api';

@Component({
  components: {
    SidebarMenu,
    Offline,
  },
})
export default class Dashboard extends Vue {
  private sidebarClosed: boolean = true;
  private online: boolean = false;

  private toggleSidebar(val: boolean) {
    this.sidebarClosed = val;
  }

  get chainProperties() {
    return this.$store.getters.getChainProperties;
  }

  get ss58Format(): number {
    return this.chainProperties?.ss58Format
  }

  public async loadKeyring(): Promise<void> {
    keyring.loadAll({
      ss58Format: this.ss58Format || 42,
      type: 'sr25519',
      isDevelopment: this.$store.state.development.status || false,
    });
  }

  public async mountWasmCrypto(): Promise<void> {
    await cryptoWaitReady();
    console.log('wasmCrypto loaded');
    this.loadKeyring();
    console.log('keyring init');
    this.$store.commit('keyringLoaded');
    console.log('keyring loaded');
  }

  public mounted(): void {
    this.mountWasmCrypto();
    this.online = navigator.onLine
    window.addEventListener('online', () => this.online = true)
    window.addEventListener('offline', () => this.online = false)
  }
}
